<div [ngClass]="{'btn-with-links': !disableDefaultStyle}" [ngStyle]="{ right: customRight, 'z-index': zIndex }" class="flex justify-content-end flex-wrap btn-with-links add-btn">
      @if (showLastSync) {
            <label class="flex mr-3 last-sync" >Last Sync:&nbsp;&nbsp;<span class="time mr-2">{{HOUR_MINUTE_FORMAT}} {{metaDataService.formatDateTimeOnTZ(lastSync, 'hh:mm a')}}</span> 
                  <i class="mi-lg mi-refresh wh-16 inline-block vertical-align-text-bottom cursor-pointer refresh-time" (click)="refreshTime()"></i> </label>
      }
      @if (showImportExportBtn) {
            <p-button styleClass="p-button-secondary" class="flex align-items-center w-4rem h-4rem p-button-secondary" (click)="menu.toggle($event)" icon="{{miIcons.MORE_HORIZONTAL}} block wh-24"></p-button>
      }
      @if(!showAuditBtn && hideAuditBtn) {
            <p-button class="flex align-items-center justify-content-center button-hide" icon="pi pi-plus" [label]="label" (click)="onAdd()" [disabled]="isBtnDisabled"></p-button>
      }
      @if (showSecondaryBtn) {
            <p-button class="flex align-items-center justify-content-center ml-1" icon="pi pi-check" [label]="secondaryBtnLabel" (click)="onSecondaryBtnClick()" ></p-button>
      }
      @if(showAuditBtn) {
            <button pButton class="flex align-items-center justify-content-center bg-white exportAuditBtn" [label]="label" (click)="onAdd()">
                  <i class="{{miIcons.EXPORT}} inline-block wh-16 mr-2 relative"></i>
            </button>
      }
      @if(showOrderExportBtn) {
            <p-button class="flex align-items-center justify-content-center ml-1" [label]="orderExportBtnLabel" (click)="orderExportBtnClick.emit()"></p-button>
      }
</div>
<div class="header-module-menu">
      <p-menu  #menu  [model]="moduleHeaderSecondaryBtnMenuItems" [popup]="true"></p-menu>
</div>